export interface CustomerContactsModel {
  contactId: number;
  customerNumber: number;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phoneNumber: string;
  faxNumber: string;
  address1: string;
  city: string;
  state: string;
  zipcode: string;
  submit?: null;
}

export const defaultCustomerContactsModel: CustomerContactsModel = {
  contactId: 0,
  customerNumber: 0,
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  phoneNumber: '',
  faxNumber: '',
  address1: '',
  city: '',
  state: '',
  zipcode: '',
};
